import React from "react";
import Helmet from "react-helmet";
import { Global, css } from "@emotion/react";
import "normalize.css";
import { globalStyles } from "../assets/styles/globals";
import { colors, heights } from "../assets/styles/variables"
import Recommended from "../components/recommended";

const notFound = css`
  height: 100%;

  &::before {
    content: '';
    display: block;
    height: ${heights.header};
    background-color: ${colors.black};
    border-bottom: 2px solid ${colors.lightgray};
    box-sizing: border-box;
  }

  &::after {
    content: '';
    display: block;
    height: ${heights.footer};
    background-color: ${colors.black};
    border-top: 2px solid ${colors.lightgray};
    box-sizing: border-box;
  }

  .container {
    height: calc(100% - (${heights.header} + ${heights.footer}));
    background-color: ${colors.blackThin};
    padding: 20px 0;
    box-sizing: border-box;
  }

  .inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    max-width: 342px;
    margin: 0 auto;
  }

  .statusText {
    padding: 10px 0;
    font-size: 20px;
    color: ${colors.white};
    text-align: center;
  }
`

const NotFoundPage = () => {
  return (
    <>
      <Helmet
        title="お探しのページが見つかりません"
      />
      <Global styles={globalStyles} />
      <div css={notFound}>
        <div className="container">
          <div className="inner">
            <p className="statusText">お探しのページが見つかりません</p>
            <Recommended />
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
